import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Login from "@/pages/Login.vue";
import Signup from "@/pages/Signup.vue";
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Hello from "@/pages/Hello.vue"



function dynamicPropsFn (route) {
  const now = new Date()
  return {
    name: (now.getFullYear() + parseInt(route.params.years)) + '!',
    gamiesai: true,
    dds: 'dss',

  }
}



const routes = [
  { path: '/', component: Login },
  { path: '/signup', component: Signup },
  { path: '/hello/:name', component: Hello, props: true }, // Pass route.params to props
  { path: '/static', component: Hello, props: { name: 'world' }}, // static values
  { path: '/dynamic/:years', component: Hello, props: dynamicPropsFn }, // custom logic for mapping between route and props
  { path: '/attrs', component: Hello, props: { name: 'attrs' }},
  //{ path: '/home', component: Home },
  {
    path: "/home",
    component: DashboardLayout,
    redirect: "/home/user",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile
      }

    ]
  }
];

export default routes;
